/**
 * Simple hook to use query parameters.
 */
export const useQueryParams = (): URLSearchParams | undefined =>
    new URLSearchParams(window.location.search);
